import { Component, OnInit } from "@angular/core";
import { BannerService } from "@app/core/services/banner.service";
import { Banner } from "@app/shared/models/banner";

@Component({
  selector: "app-banner",
  templateUrl: "./banner.component.html",
  styleUrls: ["./banner.component.scss"],
})
export class BannerComponent implements OnInit {
  banner: Banner;

  constructor(protected bannerService: BannerService) {}

  hasActiveBanner() {
    return this.banner && this.banner.id;
  }

  getActiveBanner() {
    return this.bannerService.getActiveBanner();
  }

  ngOnInit() {
    this.getActiveBanner().subscribe((banner) => {
      this.banner = banner;

      if (this.hasActiveBanner()) {
        if (this.banner.width.search(/[a-zA-Z]/) === -1) {
          this.banner.width += 'px';
        }
        if (this.banner.height.search(/[a-zA-Z]/) === -1) {
          this.banner.height += 'px';
        }
      }
    });
  }
}
